module.exports = __webpack_public_path__ + "static/media/AdminTools.9b2d8c3e.svg";